import * as rmd from 'material-ui';
import React from 'react';
import cfg from 'cfg';
import _ from 'lodash';
import TeamPicker from './TeamPicker';

class TransferPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        let keyProperty = this.getPropertyFor('transferId');

        this.state = {
            keyProperty,
            transfers: [],
            transferId: props[keyProperty] && +props[keyProperty]
        };
    }

    componentDidMount() {
        this.loadTransfers();
    }

    loadTransfers() {
        let { transferId, teamId } = this.state;

        return Promise.all([
            fetch(`${cfg.apis.ss2}/transfers${teamId ? `?teamId=${teamId}&limit=500` : ``}`).then(response =>
                response.json()
            )
        ])

            .then(([transfers, teams]) => {
                this.setState({
                    transfers,
                    teamId,
                    transferId
                });
            })
            .catch(e => {
                console.error(e);
                this.setState({ transfers: [] });
            });
    }

    getPropertyFor(key) {
        return _.get(this, `props.propsMap[${key}]`, key);
    }

    handleTeamChange = (key, teamId) => {
        this.setState(
            {
                teamId
            },
            this.loadTransfers
        );
    };

    handleTransferChange = (srting, index, value) => {
        var transfer = this.state.transfers.find(t => t.id === value);

        if (transfer) {
            this.props.onChange(this.state.keyProperty, transfer.id);
            this.setState({
                transferId: transfer.id
            });
        } else {
            this.props.onChange(this.state.keyProperty, null);
        }
    };
    renderOption(option) {
        return <rmd.MenuItem key={option.value} value={option.value} primaryText={option.text} />;
    }
    render() {
        const { transfers, transferId } = this.state;

        let transfersOptions = transfers.filter(t => t.type === 'transfer').map(t => {
            return {
                text: `${t.playerName}. ${t.fromTeamName} to ${t.toTeamName}`,
                value: t.id
            };
        });

        let rumourOptions = transfers.filter(t => t.type === 'rumour').map(t => {
            return {
                text: `${t.playerName}. ${t.fromTeamName} to ${t.toTeamName}`,
                value: t.id
            };
        });

        return (
            <div>
                <TeamPicker onChange={this.handleTeamChange} />
                <rmd.SelectField floatingLabelText="Transfer" value={transferId} onChange={this.handleTransferChange}>
                    {[{ value: null, text: 'Custom' }, ...transfersOptions].map(this.renderOption)}
                </rmd.SelectField>
                <rmd.SelectField floatingLabelText="Rumour" value={transferId} onChange={this.handleTransferChange}>
                    {[{ value: null, text: 'Custom' }, ...rumourOptions].map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default TransferPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TransferPicker.js
 **/